import {ExperienceMetadata} from '../features/applicant/profile/types';
import {YEARS_OF_EXPERIENCE} from '../lib/constants';
import {RequiredLanguageProfile, TrackRecord} from '../types/shared-types';
import {SupportedLanguages} from '../types/SupportedLanguages';

interface Display {
  id: string;
  label: string;
  value: string;
}

export const formatProfessionalExperienceDisplay = (
  data: TrackRecord<ExperienceMetadata>,
  lang: SupportedLanguages
): Display => {
  return {
    id: `${data.metadata.label}`,
    label: typeof data.name === 'string' ? data.name : (data.name as RequiredLanguageProfile)[lang],
    value: YEARS_OF_EXPERIENCE.find((it) => it.id === data.metadata.yearsOfExperience)?.label[lang] || '-',
  };
};
